import { useState } from "react";
import { Typography } from "@/design-system/Atoms";
import TestimonialViewModal from "@/design-system/Molecules/TestimonialViewModel";

interface Props {
  message: string;
  firstName: string;  
  pageName?: string;
}

const TestimonialCard = ({ message, firstName, pageName }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isTabPage = pageName === "TabPage";
  const shouldTruncate = isTabPage && message.length > 100;
  const shortMessage = shouldTruncate ? message.slice(0, 100) : message;

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <div>
        <Typography
          as="p"
          variant="sectionDescriptionSmall"
          className="text-[1.125rem] text-[#3b4151] mb-4"
        >
          {shortMessage}
          {shouldTruncate && (
            <>
              {"... "}
              <button
                onClick={handleOpenModal}
                className="inline text-[1.125rem] text-[#3b4151] underline focus:outline-none font-medium cursor-pointer"
              >
                read more
              </button>
            </>
          )}
        </Typography>

        <div className="mt-12">
          <Typography
            as="h6"
            variant="sectionDescriptionSmall"
            className="text-[1.125rem] text-[#181a20]"
          >
            {`- ${firstName}`}
          </Typography>
        </div>
      </div>

      {isTabPage && (
        <TestimonialViewModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          message={message}
          firstName={firstName}
        />
      )}
    </>
  );
};

export default TestimonialCard;
